module.exports = __webpack_public_path__ + "img/ceramicsBefore6.c7527e06.jpg";